import { getCookie, setCookie } from 'react-use-cookie';
import { ThemeMode } from '../../../services/exports/Constants';
import { ISeo, IStorefrontPageLoadingConfig } from './Interfaces';

export const getStorefrontOrigin = (): string | null =>
  import.meta.env.VITE_STOREFRONT_ORIGIN ?? getCookie('storefront_origin');
export const getStorefrontThemeMode = (): ThemeMode | null => getCookie('storefront_theme_mode') as ThemeMode | null;
export const getStorefrontFranchiseUuid = (): string | null =>
  import.meta.env.VITE_STOREFRONT_FRANCHISE_UUID ?? getCookie('storefront_franchise_uuid');
export const getStorefrontTranslationsEnabled = (): boolean => Boolean(getCookie('storefront_translations_enabled'));
export const getStorefrontLocale = (): string | null => getCookie('storefront_locale');
export const getStorefrontPageLoadingConfig = (): IStorefrontPageLoadingConfig | null => {
  const config = getCookie('storefront_page_loading_config');
  if (!config) return null;
  return JSON.parse(decodeURIComponent(config));
};
export const getStorefrontGoogleMapsApiKey = (): string | null =>
  getCookie('storefront_google_maps_api_key_v1') || null;
export const getStorefrontBasePath = (): string | null =>
  import.meta.env.VITE_CONFIG_BASE_PATH ?? getCookie('storefront_base_path');

export const saveStorefrontPageMetaData = (metaData: ISeo): void =>
  setCookie('storefront_page_meta_data', encodeURIComponent(JSON.stringify(metaData)));

export const getStorefrontPageMetaData = (): ISeo | null => {
  const metaData = getCookie('storefront_page_meta_data');
  if (!metaData) return null;
  return JSON.parse(decodeURIComponent(metaData));
};
